export default `
  {
    getItem {
        account {
        name
        dateCreated
        dateUpdated
        domain
        name
        timezone
        weekStart
        logo
        inProgress
        subscription {
            planName
            planId
            inTrial
            trialEnd
            cardStatus
            cardStatusDescription
            dataWarehouseType
            currentTermEnd
        }
        sortKey
        revisions
        status
        hasCard
        transactionStatus
        accountType
        clientId
        betaAccess
        showIncentives
        zapierWebHook
        aiCreditIncentives {
          id
          status
          proofUrl
          monthlyCredits
          lastVerifiedAt
          statusMessage
          rejectionCode
          rejectionReason
        }
        }
    }
  }
`;